/**
 * Created by mcochrane on 25/08/17.
 */
// import {ComponentDefinition} from './ComponentDefinition'
import { CustomScript } from './CustomScript'

var _customScripts = []

document._customScripts = _customScripts

window.__showAllCustomScripts = function () {
  _customScripts.forEach((cs) => {
    console.log({
      name: cs.script_name,
      type: cs.type
    })
  })
}

/**
 * Loads custom scripts from component definitions
 * @param componentDefinitions  array of ComponentDefinition
 * @param replaceMode          'relaxed':  only replace a script if the url changes
 *                              'contents': check the contents (if !is_url) and if it's changed, update
 *                              'force':    replace the script if it already exists (by name)
 * @see ComponentDefinition
 */
export function loadCustomScriptsFromComponentDefs (componentDefinitions, replaceMode = 'relaxed') {
  if (replaceMode === 'force') removeAllCustomScripts()
  componentDefinitions.forEach(function (cmpntDef) {
    if (cmpntDef.scriptDefs) {
      cmpntDef.scriptDefs.forEach(function (script) {
        addCustomScript(script.name, script.data, script.is_url, script.type, replaceMode)
      })
    }
  })
}

/**
 * Same as findCustomScript but only checks the name
 * @param name
 * @return {*}
 */
function findCustomScriptByName (name) {
  let foundScript = null
  // 'some' is like forEach but exits if the function returns true
  document._customScripts.some(function (script) {
    if (!script.loaded) return false
    if (script.script_name !== name) return false
    foundScript = script
    return true // exit the loop
  })
  return foundScript
}

/**
 * Removes a script (CustomScript object) from document._customScripts.
 * @param script
 */
export function removeCustomScript (script) {
  script.deleteFromDOM()
  let index = document._customScripts.indexOf(script)
  if (index > -1) {
    document._customScripts.splice(index, 1)
  }
}

/**
 * Removes all custom scripts from the DOM and from document._customScripts
 */
export function removeAllCustomScripts () {
  document._customScripts.forEach(function (script) {
    script.deleteFromDOM()
  })
  document._customScripts = []
}

/**
 * Logic for determining if a script should be replaced in Relaxed replaceMode
 */
function shouldReplaceScriptInRelaxedMode (script, data, isUrl, type) {
  if (script.type !== type) return true
  if (isUrl) {
    if (script.url !== data) return true
  }
  return false
}

/**
 * Logic for determining if a script should be replaced in Contents replaceMode
 */
function shouldReplaceScriptInContentsMode (script, data, isUrl, type) {
  if (script.type !== type) return true
  if (isUrl) {
    if (script.url !== data) return true
  } else {
    if (script.content !== data) return true
  }
  return false
}

/**
 * Logic for determining if a script should be replaced in Force replaceMode
 */
function shouldReplaceScriptInForceMode (script, data, isUrl, type) {
  return true
}

/**
 * Logic for determining if a script should be replaced depending on replaceMode
 * @param script            the CustomScript object that we're checking
 * @param data              the new data
 * @param isUrl            the new isUrl
 * @param type              'js' or 'css'
 * @param replaceMode      'relaxed':  Only replace a script if the url changes.
 *                          'contents': Check the contents (if !isUrl) and if it's changed, update.
 *                          'force':    Replace the script if it already exists (by name).
 * @returns {boolean}       true if the script should be replaced, false if it should not be replaced
 */
function shouldReplaceScript (script, data, isUrl, type, replaceMode) {
  if (replaceMode === 'relaxed') {
    return shouldReplaceScriptInRelaxedMode(script, data, isUrl, type)
  } else if (replaceMode === 'contents') {
    return shouldReplaceScriptInContentsMode(script, data, isUrl, type)
  } else if (replaceMode === 'force') {
    return shouldReplaceScriptInForceMode(script, data, isUrl, type)
  }
  return false
}

/**
 *
 * @param name          the name of the script
 * @param data          the url where the script can be loaded from    (isUrl == true),
 *                      or the actual javascript content of the script (isUrl == false)
 * @param isUrl        true if the data parameter is a url
 *                      false if it's the raw script (js/css)
 * @param type          either 'js' or 'css'
 * @param replaceMode  'relaxed':  only replace a script if the url changes
 *                      'contents': check the contents (if !isUrl) and if it's changed, update
 *                      'force':    replace the script if it already exists (by name)
 */
export function addCustomScript (name, data, isUrl = false, type = 'js', replaceMode = 'relaxed') {
  replaceMode = replaceMode.toLowerCase()
  let origScript = findCustomScriptByName(name)
  if (origScript !== null) {
    // Script exists!
    if (shouldReplaceScript(origScript, data, isUrl, type, replaceMode)) {
      console.log('Script ' + name + ' already exists in dom.  Replacing...')
      removeCustomScript(origScript)
    } else {
      // console.log("Script " + name + " already exists in dom but not replacing.");
      return
    }
  }
  document._customScripts.push(new CustomScript(name, data, isUrl, type))
}
